import { Typography } from '@mui/material'
import FullPageLayout from 'components/FullPageLayout/FullPageLayout'
import { useTranslation } from 'react-i18next'
import OrderwireLogo from 'views/CreateCompany/components/OrderwireLogo'
import ContactSupportButton from './ContactSupportButton'

function NoLicensePage() {
    const { t } = useTranslation()

    return (
        <FullPageLayout>
            <>
                <OrderwireLogo />
                <Typography variant="h5">
                    {t('license.message.no_license')}
                </Typography>
                <ContactSupportButton style={{ marginTop: 24 }} />
            </>
        </FullPageLayout>
    )
}

export default NoLicensePage
